export default __webpack_public_path__ + "static/media/edit_selected.bd109d31.svg";